import React from 'react';
import { IAuditoriaCambialResultado } from '../interfaces/IAuditoriaCambial';
import { TributoAuditoria } from '../interfaces/IAuditoria';

interface Props {
  resultado: IAuditoriaCambialResultado;
  onSelecionar: (tributo: TributoAuditoria) => void;
}

const formatCurrency = (v: number) =>
  v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

const AuditoriaResumoCambial: React.FC<Props> = ({ resultado, onSelecionar }) => {
  const temProblema = resultado.totalAlertas > 0 || resultado.totalAvisos > 0;
  const corBorda = resultado.totalAlertas > 0
    ? '#f59e0b'
    : resultado.totalAvisos > 0
    ? '#3b82f6'
    : '#22c55e';

  return (
    <div
      className='auditoria-card mb-4'
      style={{ borderLeft: `4px solid ${corBorda}`, cursor: 'pointer' }}
      onClick={() => onSelecionar('AUDITORIA_CAMBIAL')}
    >
      <div className='d-flex justify-content-between align-items-start'>
        <div>
          <h5 className='mb-1'>Gestão de Exposição Cambial e Eficiência de Hedge</h5>
          <small className='text-muted'>
            Contas patrimoniais no exterior (bancos, clientes, fornecedores) + indícios por nome/
            histórico (câmbio, estrangeiro, hedge) · PTAX BCB (USD/EUR)
          </small>
        </div>
        <span
          className={`badge ${
            resultado.status === 'ALERTA'
              ? 'bg-warning text-dark'
              : resultado.status === 'AVISO'
              ? 'bg-info text-dark'
              : 'bg-success'
          }`}
        >
          {resultado.status}
        </span>
      </div>

      {temProblema && (
        <div
          className='alert mt-3 mb-0 py-2 px-3'
          style={{ backgroundColor: resultado.totalAlertas > 0 ? '#fef9c3' : '#eff6ff', border: 'none' }}
        >
          <small>{resultado.mensagemDirecionamento}</small>
        </div>
      )}

      <div className='row mt-3 g-2'>
        <div className='col-6 col-md-3'>
          <div className='text-muted' style={{ fontSize: '0.75rem' }}>Exposição Fiscal Total</div>
          <div
            className='fw-bold'
            style={{ color: resultado.exposicaoFiscalTotalGeral > 0 ? '#dc2626' : '#16a34a' }}
          >
            {formatCurrency(resultado.exposicaoFiscalTotalGeral)}
          </div>
        </div>
        <div className='col-6 col-md-3'>
          <div className='text-muted' style={{ fontSize: '0.75rem' }}>Passivo Fiscal (Tf 34%)</div>
          <div className='fw-bold'>{formatCurrency(resultado.passivoFiscalTotal)}</div>
        </div>
        <div className='col-6 col-md-3'>
          <div className='text-muted' style={{ fontSize: '0.75rem' }}>Total Multas (MQ+MA)</div>
          <div className='fw-bold'>
            {formatCurrency(resultado.multaQualificadaTotal + resultado.multaAcessoriaTotal)}
          </div>
        </div>
        <div className='col-6 col-md-3'>
          <div className='text-muted' style={{ fontSize: '0.75rem' }}>Ocorrências</div>
          <div>
            {resultado.totalAlertas > 0 && (
              <span className='badge bg-warning text-dark me-1'>{resultado.totalAlertas} Alertas</span>
            )}
            {resultado.totalAvisos > 0 && (
              <span className='badge bg-info text-dark me-1'>{resultado.totalAvisos} Avisos</span>
            )}
            {!temProblema && (
              <span className='badge bg-success'>Conciliado</span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuditoriaResumoCambial;
